// utils/formatXML.js

/**
 * Converts FAQ data into XML format
 * (useful for integrations or AI chatbot ingestion)
 *
 * @param {Array} data - The FAQ data array
 * @param {string} language - The language code
 * @returns {string} XML-formatted string
 */
export function convertToXML(data, language = 'en') {
  if (!Array.isArray(data)) return '<faqs></faqs>';

  const xmlCategories = data
    .map(category => {
      const faqItems = category.details || category.faqList || [];
      const xmlItems = faqItems
        .map(item => {
          const question = escapeXML(item.question || item.title || '');
          const answer = escapeXML(item.answer || item.description || '');
          return `
        <faq>
          <question>${question}</question>
          <answer>${answer}</answer>
        </faq>`;
        })
        .join('');

      return `
      <category>
        <name>${escapeXML(category.categoryName || 'Untitled Category')}</name>
        ${xmlItems}
      </category>`;
    })
    .join('');

  return `<?xml version="1.0" encoding="UTF-8"?>
<faqs language="${language}">
  ${xmlCategories}
</faqs>`;
}

/** Helper to escape XML special characters */
function escapeXML(str = '') {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}
